import React from 'react';
import TopNavbar from '../../../home/TopNavbar';

const styles = `
    /* General body and container styling */
    
    .container {
        max-width: 1200px;
        margin: auto;
        background-color: #fff;
        padding: 10px;
        border-radius: 10px;
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
       padding-bottom: 100px;
       margin-top:30px;
    }

    /* Heading styles */
    .main-heading {
      padding-top:50px;
        color: #004d40;
        text-align: center;
        font-size: 1.5em;
        margin-bottom: 10px;
        border-bottom: 3px solid #004d40;
        padding-bottom: 10px;
    }

    .sub-heading {
        color: #00695c;
        font-size: 2em;
        margin-top: 40px;
        margin-bottom: 15px;
    }

    .table-heading {
        color: #00796b;
        font-size: 1.5em;
        margin-top: 30px;
        margin-bottom: 10px;
    }

    .sub-table-heading {
        color: #00897b;
        font-size: 1.2em;
        margin-top: 25px;
        margin-bottom: 10px;
        text-transform: uppercase;
    }

    /* Paragraph styles */
    .intro-paragraph, .section-paragraph {
        font-size: 1em;
        text-align: justify;
        margin-bottom: 20px;
    }

    /* Table styles */
    table {
        width: 100%;
        border-collapse: collapse;
        margin-top: 20px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    }

    th, td {
        padding: 12px;
        text-align: left;
        border: 1px solid #ddd;
    }

    thead th {
        background-color: #004d40;
        color: #fff;
        font-weight: bold;
        text-transform: uppercase;
    }

    /* Alternating row colors for better readability */
    tbody tr:nth-child(even) {
        background-color: #e8f5e9;
    }

    tbody tr:nth-child(odd) {
        background-color: #f0fdf2;
    }

    /* Hover effect on table rows */
    tbody tr:hover {
        background-color: #c8e6c9;
        transition: background-color 0.3s ease;
    }

    /* Styling for the total row */
    tbody tr:last-child {
        font-weight: bold;
        background-color: #b2dfdb !important;
    }

    tbody tr:last-child td {
        border-top: 2px solid #004d40;
    }
`;

const BotanyData = [
    { class: "11th", chapter: "Respiration in Plants", questions: 1 },
    { class: "11th", chapter: "Cell: The Unit of Life", questions: 5 },
    { class: "11th", chapter: "Morphology of Flowering Plants", questions: 3 },
    { class: "11th", chapter: "Plant Growth and Development", questions: 2 },
    { class: "11th", chapter: "Plant Kingdom", questions: 5 },
    { class: "11th", chapter: "Biological Classification", questions: 1 },
    { class: "11th", chapter: "Anatomy of Flowering Plants", questions: 1 },
    { class: "11th", chapter: "Photosynthesis in Higher Plants", questions: 2 },
    { class: "11th", chapter: "Cell Cycle and Cell Division", questions: 1 },
    { class: "12th", chapter: "Molecular Basis of Inheritance", questions: 7 },
    { class: "12th", chapter: "Organisms and Populations", questions: 3 },
    { class: "12th", chapter: "Biodiversity and Conservation", questions: 2 },
    { class: "12th", chapter: "Ecosystem", questions: 4 },
    { class: "12th", chapter: "Sexual Reproduction in Flowering Plants", questions: 5 },
    { class: "12th", chapter: "Microbes in Human Welfare", questions: 4 },
    { class: "12th", chapter: "Principles of Inheritance and Variation", questions: 3 },
];

const ZoologyData = [
    { class: "11th", chapter: "Structural Organisation in Animals (Animal Tissues)", questions: 4 },
    { class: "11th", chapter: "Locomotion and Movement", questions: 1 },
    { class: "11th", chapter: "Animal Kingdom", questions: 4 },
    { class: "11th", chapter: "Body Fluids and Circulation", questions: 1 },
    { class: "11th", chapter: "Biomolecules", questions: 4 },
    { class: "11th", chapter: "Excretory Products and their Elimination", questions: 1 },
    { class: "11th", chapter: "Chemical Coordination and Integration", questions: 4 },
    { class: "11th", chapter: "Biotechnology and its Applications", questions: 4 },
    { class: "12th", chapter: "Biotechnology - Principles and Processes", questions: 6 },
    { class: "12th", chapter: "Reproductive Health", questions: 1 },
    { class: "12th", chapter: "Human Reproduction", questions: 5 },
    { class: "12th", chapter: "Biotechnology and its Applications", questions: 5 },
    { class: "12th", chapter: "Human Health and Disease", questions: 4 },
    { class: "12th", chapter: "Evolution", questions: 1 },
];

const renderTable = (data) => (
    <table>
        <thead>
            <tr>
                <th>Class</th>
                <th>Chapter Name</th>
                <th>No. of Questions</th>
            </tr>
        </thead>
        <tbody>
            {data.map((item, index) => (
                <tr key={index}>
                    <td>{item.class}</td>
                    <td>{item.chapter}</td>
                    <td>{item.questions}</td>
                </tr>
            ))}
            <tr>
                <td colSpan="2"><strong>Total</strong></td>
                <td><strong>{data.reduce((sum, item) => sum + item.questions, 0)}</strong></td>
            </tr>
        </tbody>
    </table>
);

const NeetWeightageBiology = () => {
    return (
        <div>
            <style>{styles}</style>
            <div className="container">
                 <TopNavbar name="Physics Weightage" />
                <h1 className="main-heading">Chapter-wise Weightage in NEET Previous Year Paper</h1>
                <p className="intro-paragraph">
                    The Chapter-wise NEET 2025 Paper Analysis offers a comprehensive review of the distribution of questions across individual chapters from Physics, Chemistry, and Biology. This analysis systematically identifies the chapters that received greater emphasis in the NEET 2025 examination, highlighting areas of high question frequency and conceptual significance.
                </p>

                <h2 className="sub-heading">Biology Chapter-wise Weightage in NEET 2025 Paper</h2>
                <p className="section-paragraph">
                    The Chapter-wise NEET 2025 Biology Paper Analysis highlights the distribution of questions from key chapters like Human Physiology, Genetics, and Plant Physiology. It helps students identify high-weightage topics and understand the pattern of questions asked. This insight allows focused and strategic preparation for NEET 2026.
                </p>

                <h3 className="table-heading">Chapter-Wise NEET 2025 Biology Weightage</h3>

                <h4 className="sub-table-heading">NEET Biology Chapter-wise Weightage for Botany</h4>
                {renderTable(BotanyData)}

                <h4 className="sub-table-heading">NEET Biology Chapter wise Weightage for Zoology</h4>
                {renderTable(ZoologyData)}
            </div>
        </div>
    );
};

export default NeetWeightageBiology;